import axios from 'axios'
import useNotification from '@/services/useNotification'
import personalRepository from '@/services/repositories/personal-repository'
import handleErrors from '@/services/handleErrors'

const { showSuccessNotification } = useNotification()

const actions = {
  async fetchUserProfile() {
    this.fetchIsLoading = true
    try {
      const data = await personalRepository.profile()
      this.id = data.id
      this.name = data.name
      this.phone = data.phone
      this.email = data.email
      this.balance = data.balance
      this.accountType = data.accountType
      this.accountManager = data.accountManager
      this.companyName = data.companyName
      this.companyAddress = data.companyAddress
      this.companySite = data.companySite
      this.vat = data.vat
      this.additionalInfo = data.additionalInfo
      this.adActionsNotifications = data.adActionsNotifications
      this.campaignActionsNotifications = data.campaignActionsNotifications
      this.campaignTooltipsNotifications = data.campaignTooltipsNotifications
      this.trafficProviderSubscription = data.trafficProviderSubscription
      this.referralProgramPercent = data.referralProgramPercent
      this.isCompanyVerified = data.isCompanyVerified
      this.verificationStatuses = data.verificationStatuses
      this.twoFactorAuthenticationMethod = data.twoFactorAuthenticationMethod
      this.recurringPaymentsCustomer = data.recurringPaymentsCustomer
      this.userMessengers = data.messengers
      this.fullManageStatus = data.fullManageStatus
      this.actions = data.actions
      this.subscribeTelegram = data.messengers.find(({ name }) => name === 'Telegram')?.messenger_user_id ?? null
      this.fetchIsLoading = false
    } catch (error) {
      if (!axios.isCancel(error)) {
        this.fetchIsLoading = false
      }
      handleErrors(error)
    }
  },
  resetRecurringPaymentsCustomers() {
    this.recurringPaymentsCustomer = []
  },
  changeUserName(name) {
    this.name = name
  },
  changePhone(phone) {
    this.phone = phone
  },
  setUserMessengers(messengers) {
    this.userMessengers = messengers
  },
  removeUserMessenger(removingMsgIndex) {
    this.userMessengers.splice(removingMsgIndex, 1)
  },
  changeAccountType(accountType) {
    this.accountType = accountType
  },
  changeCompanyName(companyName) {
    this.companyName = companyName
  },
  changeCompanyAddress(companyAddress) {
    this.companyAddress = companyAddress
  },
  changeCompanySite(companySite) {
    this.companySite = companySite
  },
  changeVat(vat) {
    this.vat = vat
  },
  changeAdditionalInfo(additionalInfo) {
    this.additionalInfo = additionalInfo
  },
  changeAdActionsNotifications(adActionsNotifications) {
    this.adActionsNotifications = adActionsNotifications
  },
  changeCampaignActionsNotifications(campaignActionsNotifications) {
    this.campaignActionsNotifications = campaignActionsNotifications
  },
  changeCampaignTooltipNotifications(campaignTooltipsNotifications) {
    this.campaignTooltipsNotifications = campaignTooltipsNotifications
  },
  changeTwoFactorAuthenticationMethod(twoFactorAuthenticationMethod) {
    this.twoFactorAuthenticationMethod = twoFactorAuthenticationMethod
  },
  async saveUserProfile() {
    this.saveIsLoading = true
    try {
      await personalRepository.update(this.getRequestPersonal)
      showSuccessNotification('Profile data updated successfully')
      this.errors = {}
      await this.fetchUserProfile()
    } catch (error) {
      const errors = error.response?.data?.errors
      if (errors) {
        const errorsMessages = {
          name: errors.name,
          accountType: errors.account_type,
          companyName: errors.company_name,
          companyAddress: errors.company_address,
          companySite: errors.company_site,
          vat: errors.vat,
          additionalInfo: errors.additional_info,
          adActionsNotifications: errors.notifications_about_ad_actions,
          campaignActionsNotifications: errors.notifications_about_campaign_actions,
          campaignTooltipsNotifications: errors.notifications_about_campaign_tooltips,
          twoFactorAuthenticationMethod: errors.two_factor_authentication_method
        }
        this.errors = { ...errorsMessages, ...errors }
      }
    }
    this.saveIsLoading = false
  }
}

export default actions